import React from 'react';
import Text from './Text';

const TextForHeading = (name, headingProps = {}) => {
  const textProps = { margin: 0, ...headingProps };
  const HeadingText = props => <Text {...textProps} {...props} />;

  HeadingText.displayName = name;
  HeadingText.propTypes = Text.propTypes;

  return HeadingText;
};

const NAMES = {
  H1: 'H1',
  H2: 'H2',
  H3: 'H3',
  H4: 'H4',
  H5: 'H5',
  H6: 'H6',
};

const PROPS = {
  [NAMES.H1]: {
    fontSize: 32,
    fontWeight: 500,
    lineHeight: '48px',
    color: 'darkBlack',
  },
  [NAMES.H2]: {
    fontSize: 24,
    fontWeight: 500,
    lineHeight: '36px',
    color: 'darkBlack',
  },
  [NAMES.H3]: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: '30px',
    color: 'darkBlack',
  },
  [NAMES.H4]: { fontSize: 16, fontWeight: 500, lineHeight: '24px' },
  [NAMES.H5]: { fontSize: 14, fontWeight: 400, lineHeight: '22px' },
  [NAMES.H6]: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '14px',
    color: 'greyDark',
  },
};

export const H1 = TextForHeading(NAMES.H1, PROPS.H1);
export const H2 = TextForHeading(NAMES.H2, PROPS.H2);
export const H3 = TextForHeading(NAMES.H3, PROPS.H3);
export const BodyText = TextForHeading(NAMES.H4, PROPS.H4);
export const SubBodyText = TextForHeading(NAMES.H5, PROPS.H5);
export const CaptionText = TextForHeading(NAMES.H6, PROPS.H6);

export const HeroBanner = props => (
  <Text fontSize={48} lineHeight="72px" color="darkBlack" {...props} />
);
